import { Client } from "@gadget-client/papamedic-ai"

export const api = new Client({ environment: window.gadgetConfig.environment });
